<div class="container" *ngIf="messages.length">
    <ul>
        <li *ngFor="let message of messages">{{message}}</li>
    </ul>
</div>